export default function ResponseAgent({ responseAgent, response, handleCancelConvertCallToCallback, handleConvertCallToCallback }: { responseAgent: boolean, response?: any, handleCancelConvertCallToCallback: (call_id: string) => void; handleConvertCallToCallback: (call_id: string) => void; }) {
    if (responseAgent) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {response.title}
                </h3>
                <div className="animate-pulse text-purple-600 font-medium">
                    {response.message}
                </div>
                {response.more_info ? (
                    <div className="mt-4 p-4 text-purple-700 text-center">
                        <small>Ønsker du at agenten skal ringe deg tilbake innen de neste X timene?</small>
                        <div className="mt-2">
                            <button
                                onClick={() => handleCancelConvertCallToCallback(response.more_info.call_history_id)}
                                className="bg-black text-white px-4 py-2 rounded-full"
                            >
                                Ingen
                            </button>
                            &nbsp;&nbsp;
                            <button
                                onClick={() => handleConvertCallToCallback(response.more_info.call_history_id)}
                                className="bg-green-500 text-white px-4 py-2 rounded-full"
                            >
                                Ja
                            </button>
                        </div>
                    </div>
                ) : (<></>)}
            </section>
        )
    }
}